import {
  GetListingsDrawerStateDocument,
  useGetListingsDrawerStateQuery,
} from '@kijiji/generated/graphql-types'
import { useCallback } from 'react'

export const useListingsDrawerState = () => {
  /** Read current value from the cache */
  const { data, client } = useGetListingsDrawerStateQuery()
  const { srp: { isListingsDrawerOpen = false } = {} } = data ?? {}

  const setListingsDrawerState = useCallback(
    ({ isOpen }: { isOpen?: boolean }) => {
      client.cache.writeQuery({
        query: GetListingsDrawerStateDocument,
        data: {
          srp: {
            ...data?.srp,
            isListingsDrawerOpen: isOpen ?? !!data?.srp.isListingsDrawerOpen,
          },
        },
      })
    },
    [client.cache, data]
  )

  return {
    setListingsDrawerState,
    isListingsDrawerOpen,
  }
}
